import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class NavigationService {
  public navigationHandler$ = new EventEmitter<any>();

  constructor() {}
}
